import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { DomainsService } from '../../../core/services/domains.service';
import * as UserDomainsActions from './user-domains.actions';

@Injectable()
export class UserDomainsEffects {
  private actions$ = inject(Actions);
  private domainsService = inject(DomainsService);

  loadUserDomains$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserDomainsActions.loadUserDomains),
      switchMap(({ page, perPage }) =>
        this.domainsService.getUserDomains(page, perPage).pipe(
          map((response) =>
            UserDomainsActions.loadUserDomainsSuccess({
              domains: response.data,
              meta: response.meta,
            })
          ),
          catchError((error) =>
            of(
              UserDomainsActions.loadUserDomainsFailure({
                error: error.message || 'Failed to load domains',
              })
            )
          )
        )
      )
    )
  );
}

